var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _class, _class2, _descriptor, _descriptor2, _descriptor3, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and set to use loose mode. ' + 'To use proposal-class-properties in spec mode with decorators, wait for ' + 'the next major version of decorators in stage 2.'); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Component, Prop, Event, EventEmitter, State, Watch, html, directive, styleMap } from '@sick-davinci/ce-decorators';
import { style } from '../slider/Slider.style';
import { AbstractSlider } from '../slider/AbstractSlider';
const keyCodeTab = 9;
const keyCodeArrowLeft = 37;
const keyCodeArrowUp = 38;
const keyCodeArrowRight = 39;
const keyCodeArrowDown = 40;
const set = new WeakMap(); // WeakSet needs Polyfill, weak map is built in

const pressEventType = 'onpointerdown' in document ? 'pointerdown' : 'ontouchstart' in document ? 'touchstart' : 'mousedown';
const moveEventType = 'onpointerdown' in document ? 'pointermove' : 'ontouchstart' in document ? 'touchmove' : 'mousemove';
const releaseEventType = 'onpointerdown' in document ? 'pointerup' : 'ontouchstart' in document ? 'touchend' : 'mouseup';
const cancelEventType = 'onpointerdown' in document ? 'pointercancel' : 'ontouchstart' in document ? 'touchend' : 'mouseleave';
const pressEventDirective = directive(callback => part => {
  if (set.has(part)) {
    return;
  } else {
    part.element.addEventListener(pressEventType, callback);
    set.set(part, true);
  }
});
/**
 * A range-slider can be used to define a value range within a specific range.
 * Inherits from `davinci-abstract-slider`.
 * 
 * @example
 * ```html
 * <davinci-range-slider icon-left="av/volume_mute" value="[25,75]" icon-right="av/volume_up"></davinci-range-slider>
 * ```
 * 
 * @slot {*} title of the slider
 */

export let RangeSlider = (_dec = Component({
  tag: 'davinci-range-slider',
  style: [style],
  dependencies: [AbstractSlider]
}), _dec2 = Prop({
  reflectAsAttribute: true
}), _dec3 = Reflect.metadata("design:type", typeof Array === "undefined" ? Object : Array), _dec4 = Event(), _dec5 = Reflect.metadata("design:type", typeof EventEmitter === "undefined" ? Object : EventEmitter), _dec6 = Event(), _dec7 = Reflect.metadata("design:type", typeof EventEmitter === "undefined" ? Object : EventEmitter), _dec8 = State(), _dec9 = Reflect.metadata("design:type", typeof Array === "undefined" ? Object : Array), _dec10 = Watch('min'), _dec11 = Reflect.metadata("design:paramtypes", []), _dec12 = Watch('max'), _dec13 = Reflect.metadata("design:paramtypes", []), _dec(_class = (_class2 = (_temp = class RangeSlider extends AbstractSlider {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "change", _descriptor, this);

    _initializerDefineProperty(this, "input", _descriptor2, this);

    _initializerDefineProperty(this, "relativeValues", _descriptor3, this);

    this._internalValues = [this.min, this.max];
    this._lastPickedKnob = 0;

    this.focusEvent = () => {
      this._addCurrentKnobClass('focused');
    };

    this.focusOutEvent = () => {
      this._removeCurrentKnobClass('focused');

      this._lastPickedKnob = 0;
    };

    this.keyDownEvent = event => {
      if (event.keyCode === keyCodeArrowUp || event.keyCode === keyCodeArrowRight) {
        this._updateLastPickedKnob(this._increment(), true, false);

        event.preventDefault();
      } else if (event.keyCode === keyCodeArrowDown || event.keyCode === keyCodeArrowLeft) {
        this._updateLastPickedKnob(this._decrement(), true, false);

        event.preventDefault();
      } else if (!this.disabled) {
        if (event.shiftKey && event.keyCode === keyCodeTab) {
          if (this._lastPickedKnob === 1) {
            this._updateKnobSelectionTo('0');
          } else {
            // Continue with default shift+tab action
            return;
          }
        } else if (event.keyCode === keyCodeTab) {
          if (this._lastPickedKnob === 0) {
            this._updateKnobSelectionTo('1');
          } else {
            // Continue with default tab action
            return;
          }
        }

        event.preventDefault();
        event.stopPropagation();
      }
    };

    this.keyUpEvent = event => {
      if (event.keyCode === keyCodeArrowUp || event.keyCode === keyCodeArrowRight) {
        this._updateLastPickedKnob(this._increment(), false, true);

        event.preventDefault();
      } else if (event.keyCode === keyCodeArrowDown || event.keyCode === keyCodeArrowLeft) {
        this._updateLastPickedKnob(this._decrement(), false, true);

        event.preventDefault();
      }
    };

    this.downEvent = event => {
      event.preventDefault();
      event.stopPropagation();

      this._updateKnobSelectionTo(event.target.dataset.id);

      this._addCurrentKnobClass('pressed');

      document.addEventListener(moveEventType, this.moveEvent);
      document.addEventListener(releaseEventType, this.releaseEvent);
      document.addEventListener(cancelEventType, this.releaseEvent);
    };

    this.moveEvent = event => {
      event.preventDefault();
      event.stopPropagation();

      if (!this.requestAnimationFrame) {
        // debounce events for a smoother experience
        this.requestAnimationFrame = window.requestAnimationFrame(() => {
          const value = this.calcValueFrom(this.getPositionXOf(event));

          this._updateLastPickedKnob(value, true, false);

          this.requestAnimationFrame = null;
        });
      }
    };

    this.releaseEvent = event => {
      event.preventDefault();
      event.stopPropagation();

      if (this.requestAnimationFrame) {
        window.cancelAnimationFrame(this.requestAnimationFrame);
        this.requestAnimationFrame = null;
      }

      const value = this.calcValueFrom(this.getPositionXOf(event));

      this._updateLastPickedKnob(value, false, true);

      document.removeEventListener(moveEventType, this.moveEvent);
      document.removeEventListener(releaseEventType, this.releaseEvent);
      document.removeEventListener(cancelEventType, this.releaseEvent);

      this._removeCurrentKnobClass('pressed');

      if (this !== document.activeElement) {
        this._removeCurrentKnobClass('focused');
      }
    };

    this.clickJumpEvent = event => {
      this._removeCurrentKnobClass('focused');

      const value = this.calcValueFrom(this.getPositionXOf(event));
      this._lastPickedKnob = this._getClosestKnobFor(value);

      this._addCurrentKnobClass('focused');

      this._updateLastPickedKnob(value, true, false);

      this.downEvent(event);
    };
  }

  get value() {
    return this._internalValues;
  }
  /**
   * Set the current value.
   */


  set value(values) {
    this._adaptValues(values);
  }
  /**
   * Emitted [Array<Number>] if the value changes.
   */


  render() {
    return html`
    <div class="slider">
      <div class="slotwrapper">
        <slot></slot>
      </div>
      <div class=icon>${this.renderIcon(this.iconSrcLeft, this.iconLeft)}</div>
      <div class="bar_container" @="${pressEventDirective(this.clickJumpEvent)}" >
        <div class="bar_outer" >
          ${this._drawInnerBar()}
          <div class="touch_container">
            ${this._addKnob0()}
            ${this._addKnob1()}
          </div>
        </div>
        ${this.displayLegend()}
      </div>
      <div class=icon>${this.renderIcon(this.iconSrcRight, this.iconRight)}</div>
    </div>
    `;
  }

  componentConnected() {
    this._adaptValues(this.value);

    this.addEventListener('focus', this.focusEvent);
    this.addEventListener('focusout', this.focusOutEvent);
    this.addEventListener('keydown', this.keyDownEvent);
    this.addEventListener('keyup', this.keyUpEvent);
    this.disabledChangeHandler(this.disabled, this.disabled);
  }

  componentDisconnected() {
    this.removeEventListener('focus', this.focusEvent);
    this.removeEventListener('focusout', this.focusOutEvent);
    this.removeEventListener('keydown', this.keyDownEvent);
    this.removeEventListener('keyup', this.keyUpEvent);
  }

  updateMin() {
    if (this._internalValues !== undefined) {
      this._adaptValues([this.min, this.max]);
    }
  }

  updateMax() {
    if (this._internalValues !== undefined) {
      this._adaptValues([this.min, this.max]);
    }
  }

  _adaptValues(values) {
    if (!Array.isArray(values)) {
      values = [0, 0];
    }

    values.forEach((value, index) => {
      value = this.roundWithTicks(value);
      value = this.validateValue(value);
      value = index === 0 && value >= this._internalValues[1] ? this._internalValues[1] : value;
      value = index === 1 && value <= this._internalValues[0] ? this._internalValues[0] : value;
      this._internalValues[index] = value;
      this.relativeValues[index] = this.map(value, this.min, this.max, 0, 100);
    });
    this.relativeValues = [this.relativeValues[0], this.relativeValues[1]];
  }

  _increment() {
    const value = this._lastPickedKnob === 0 ? this._internalValues[0] : this._internalValues[1];
    return this.validateValue(value + this.ticks);
  }

  _decrement() {
    const value = this._lastPickedKnob === 0 ? this._internalValues[0] : this._internalValues[1];
    return this.validateValue(value - this.ticks);
  }

  _updateLastPickedKnob(value, emitInput, emitChange) {
    if (this._internalValues[this._lastPickedKnob] !== value || emitChange) {
      this.value = this._lastPickedKnob === 0 ? [value, this._internalValues[1]] : [this._internalValues[0], value];

      if (this._lastPickedKnob === 0 && value <= this._internalValues[1] || this._lastPickedKnob === 1 && value >= this._internalValues[0]) {
        if (emitInput) {
          this.input.emit(this._internalValues);
        }

        if (emitChange) {
          this.change.emit(this._internalValues);
        }
      }
    }
  }

  _getClosestKnobFor(value) {
    const closestValue = this._internalValues.reduce((prev, curr) => {
      return Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev;
    });

    return this._internalValues[1] < value ? 1 : this._internalValues.indexOf(closestValue);
  }

  _updateKnobSelectionTo(id) {
    this._removeCurrentKnobClass('focused');

    if (id !== undefined) {
      this._lastPickedKnob = parseInt(id, 0);
    }

    this._addCurrentKnobClass('focused');
  }

  _addCurrentKnobClass(className) {
    this.shadowRoot.querySelector('[data-id="' + this._lastPickedKnob + '"]').classList.add(className);
  }

  _removeCurrentKnobClass(className) {
    this.shadowRoot.querySelector('[data-id="' + this._lastPickedKnob + '"]').classList.remove(className);
  }

  _addKnob0() {
    return html`<div class="knob" style="${styleMap({
      left: this.relativeValues[0] + '%'
    })}"
      @="${pressEventDirective(this.downEvent)}" data-id="0"></div>`;
  }

  _addKnob1() {
    return html`<div class="knob" style="${styleMap({
      left: this.relativeValues[1] + '%'
    })}"
        @="${pressEventDirective(this.downEvent)}" data-id="1"></div>`;
  }

  _drawInnerBar() {
    return html`<div class="bar_inner" style="${styleMap({
      'margin-left': this.relativeValues[0] + '%',
      'width': this.relativeValues[1] - this.relativeValues[0] + '%'
    })}"></div>`;
  }

}, _temp), (_applyDecoratedDescriptor(_class2.prototype, "value", [_dec2, _dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "value"), _class2.prototype), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "change", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "input", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "relativeValues", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [this.min, this.max];
  }
}), _applyDecoratedDescriptor(_class2.prototype, "updateMin", [_dec10, _dec11], Object.getOwnPropertyDescriptor(_class2.prototype, "updateMin"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateMax", [_dec12, _dec13], Object.getOwnPropertyDescriptor(_class2.prototype, "updateMax"), _class2.prototype)), _class2)) || _class);
//# sourceMappingURL=RangeSlider.js.map